import type { ServiceIntervalConfig } from '../../../types';

import { getUnitSuffix } from './getUnitSuffix';

type OemLabelStrings = {
    CHARGE_CYCLES: string;
    FLIGHT_HOURS: string;
    INTERVAL_OEM_DEFAULT: (params: { value: string }) => string;
    UNIT_FLIGHTS: string;
};

// Builds the muted "OEM 100 h" label for a part's manufacturer default.
export const getOemLabel = ({
    config,
    strings
}: {
    config: ServiceIntervalConfig;
    strings: OemLabelStrings;
}): string => {
    const suffix = getUnitSuffix({ strings, unit: config.unit });

    return strings.INTERVAL_OEM_DEFAULT({ value: `${config.value} ${suffix}` });
};
